export default __webpack_public_path__ + "static/otero-34588e1070ae23805d4f75d22905c148.jpg";